export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-Post-Favorite-c6dc9e480864337cb09c6d75abb9adaa.png";